export default __webpack_public_path__ + "static/media/Robert_sq.c0ee7c0b.jpeg";